import styled from "styled-components";
import colors from "../../styles/colors";
import logoImg from "../../assets/logo.png";
import successImg from "../../assets/success.png";

export const Page = styled.section``;

export const Logo = styled.img.attrs({
  src: logoImg,
})``;

export const Success = styled.img.attrs({
  src: successImg,
})``;

export const PageContent = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  padding: 72px 0;
  max-width: 540px;
`;

export const LogoTitle = styled.h3`
  color: ${colors.yellow};
  text-transform: uppercase;
  font-size: 20px;
  margin: 14px auto 38px auto;
`;

export const MainContent = styled.div`
  text-align: center;
  color: #fff;
  h1 {
    font-size: 44px;
    margin: 0 auto;
    margin-bottom: 30px;
    text-transform: uppercase;
    max-width: 320px;
  }
`;

export const ButtonsArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 32px;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: ${colors.green};
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  padding: 16px 24px;
  transition: 300ms ease;

  &:hover {
    transform: scale(0.95);
  }

  @media screen and (max-width: 480px) {
    width: 100%;
  }
`;

export const SignInButton = styled(Button)`
  background-color: ${colors.red};
`;
